import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import "./team.css";
import { Link } from 'react-router-dom';
//import team images

import vijay from "../../assets/images/Team/vijay_khunt-.jpg";
import Yagnik from "../../assets/images/Team/Yagnik3.jpg";
import Bhavesh from "../../assets/images/Team/bhavesh-kanzariya-img.jpg";
import Kajal from "../../assets/images/Team/kajal-panchal-img.jpg";
import Nikul from "../../assets/images/Team/nikul-sabhani.jpg";
import Rakesh from "../../assets/images/Team/rakesh-prajapati.jpg";
import Jaydeep from "../../assets/images/Team/jaydip-solanki-img.jpg";
import Krinal from "../../assets/images/Team/krinal.png";
import SEO from "../seo";

export default function About() {
        const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];  
    return (
        <div>
              <SEO
                title="Our Team"
                description="Team Members Web Development Vijay Khunt Web Developer Vijay Khunt Web Developer Janvi Sharma Jr.ReactJs Developer Janvi Sharma Jr.ReactJs Developer Bhavesh Kanzariya Php Developer Bhavesh Kanzariya Php Developer Kajal Panchal Php Developer Kajal Panchal Php Developer Team Members Application Development Nikul Sabhani Mobile App Developer Nikul Sabhani Mobile App Developer Rakesh Prajapati Php Developer Rakesh [&hellip;]"
                canonical="https://www.hwplindia.com/company/our-team/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/vijay_khunt-.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Our Team</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Company</li>
                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Our Team</li>
                    </ul>
                </div>
            </section>
            <section className="team-three">
                <div className="auto-container">
                    <div className="row clearfix">
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={vijay} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Vijay Khunt</a>
                                        </h5>
                                        <div className="team-two_block-designation">
                                            Web Developer
                                        </div>
                                    </div>

                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Yagnik} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Yagnik Mayani</a>
                                        </h5>
                                        <div className="team-two_block-designation">
                                             React.js Developer
                                        </div>
                                    </div>

                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Bhavesh} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Bhavesh Kanzariya</a>
                                        </h5>
                                        <div className="team-two_block-designation">
                                           Php Developer
                                        </div>
                                    </div>
                                   
                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Kajal} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Kajal Panchal</a>
                                        </h5>
                                        <div className="team-two_block-designation">
                                           Php Developer
                                        </div>
                                    </div>
                                   
                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Nikul} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Nikul Sabhani</a>
                                        </h5>
                                        <div className="team-two_block-designation">Mobile App Developer</div>
                                    </div>
                                    
                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Rakesh} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Rakesh Prajapati</a>
                                        </h5>
                                        <div className="team-two_block-designation">
                                          Php Developer
                                        </div>
                                    </div>
                                    
                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Jaydeep} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Jaydip Solanki</a>
                                        </h5>
                                        <div className="team-two_block-designation">Laravel Developer</div>
                                    </div>
                                  
                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                        {/* Team Block Two */}
                        <div className="team-two_block col-lg-3 col-md-4 col-sm-12">
                            <div className="team-two_block-inner">
                                <div className="team-two_block-image">
                                    <a href="#">
                                        <img src={Krinal} alt="" />
                                    </a>
                                </div>
                                <div className="team-two_block-content1">
                                    <div className="upper-box-team">
                                        <h5 className="team-two_block-heading1">
                                            <a href="#">Krinal Poshiya</a>
                                        </h5>
                                        <div className="team-two_block-designation">Odoo Developer</div>
                                    </div>
                                    
                                    {/* Social Box */}
                                    {/* <ul className="team-two_social_box">
                                        <li>
                                            <a
                                                href="https://www.twitter.com/"
                                                className="fa-brands fa-facebook-f fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/"
                                                className="fa-brands fa-twitter fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/"
                                                className="fa-brands fa-linkedin fa-fw"
                                            />
                                        </li>
                                        <li>
                                            <a
                                                href="https://instagram.com/"
                                                className="fa-solid fa-instagram fa-fw"
                                            />
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

        </div>
    );
}